<template>
  <Dialog :open="authModal.isOpen" @update:open="authModal.onClose">
    <DialogContent class="sm:max-w-md">
      <DialogHeader class="items-center text-center">
        <div class="mx-auto mb-2 grid h-14 w-14 place-items-center rounded-2xl bg-primary/10 text-primary">
          <Icon name="lucide:lock" class="h-7 w-7" />
        </div>
        <DialogTitle class="text-xl font-bold">{{ $t("authModal.title") }}</DialogTitle>
        <DialogDescription class="mx-auto max-w-xs text-sm text-muted-foreground">
          {{ $t("authModal.description") }}
        </DialogDescription>
      </DialogHeader>
      <div class="space-y-2.5 pt-1">
        <Button class="w-full" @click="goToLogin">
          <Icon name="lucide:log-in" class="me-2 h-4 w-4" />
          {{ $t("authModal.loginButton") }}
        </Button>
        <Button variant="outline" class="w-full" @click="goToSignUp">
          <Icon name="lucide:user-plus" class="me-2 h-4 w-4" />
          {{ $t("authentication.sign_up") }}
        </Button>
        <button
          type="button"
          class="mx-auto block pt-1 text-sm text-muted-foreground transition hover:text-foreground"
          @click="authModal.onClose"
        >
          {{ $t("buttons.cancel") }}
        </button>
      </div>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { useAuthModal } from "@/store/useAuthModal";

const authModal = useAuthModal();

const goToLogin = () => {
  authModal.onClose();
  navigateTo("/auth");
};

const goToSignUp = () => {
  authModal.onClose();
  navigateTo("/auth?view=sign_up");
};
</script>

<style scoped></style>
